// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"b660f5ce","256":"a7643e68","497":"4792cc77","686":"8c498788","704":"75dee498","787":"6d6182e9","953":"39f88550","988":"7fc7ccae"}[chunkId] + ".chunk.js";
};